import { useLayoutContext } from '../../../Context/Layout.context';
import { updateFaq } from '../../../services/support/faq/supportFaq.service';
import { IFaqListItem } from '../../../services/support/faq/supportFaq.types';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { FaqEditor } from '../FaqEditor/FaqEditor.component';

interface EditFaqProps {
  onClose: () => void;
  onChange: () => void;
  faqProp: IFaqListItem;
}

export const EditFaq: React.FC<EditFaqProps> = ({ onClose, onChange, faqProp: faqProp }) => {

  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();
  useDocumentTitle('Edytuj pytanie');

  const handleEditFaq = (id: string, newQuestion: string, newAnswer: string) => {
    updateFaq(id, newQuestion, newAnswer).then(
      () => {
        openAlert('success');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <FaqEditor
      title="Edytuj pytanie i odpowiedź"
      onCancel={handleClose}
      onSave={handleEditFaq}
      onChange={onChange}
      question={faqProp.question}
      answer={faqProp.answer}
      faqId={faqProp.id}
    />
  );
};
